import {
  AUDIT_LOG_OPERATIONS,
  PERM_MOD_SETTINGS_AUDIT_LOG,
} from 'src/constants';
import { useAppSelector } from 'src/hooks/useStore';
import * as UserUtils from 'src/utils/UserUtils';

export interface AuditLogGate {
  /**
   * Whether the plan includes the audit log, read from the plan-permission
   * limit the backend publishes (plan_permissions.go) — Advanced and
   * Enterprise carry it. Trials preview the feature through their own
   * isTrialing path, not through this entitlement.
   */
  allowAuditLog: boolean;
}

/**
 * Plan gating for the audit log, the same shape as {@link useMfaEnforcementGate}:
 * the backend plan-permission map is the single source of which plans include
 * the feature, so the sidebar badge and the page gate can never disagree with
 * it. Studio and Classic maps both publish the limit.
 */
export const useAuditLogGate = (): AuditLogGate => {
  const permissions = useAppSelector((state) => state.user.data?.permissions);

  const viewOperation = UserUtils.getOperation(
    PERM_MOD_SETTINGS_AUDIT_LOG,
    AUDIT_LOG_OPERATIONS.VIEW,
    permissions,
  );

  return {
    allowAuditLog: (viewOperation?.planLimit ?? 0) > 0,
  };
};
